import Instance from "./instance";

export const GetSlideConfiguration = async () => {
    try {
        return await Instance.instanceToken.get(`/slideconfiguration`);
    } catch (error) {
        return error;
    }
};
export const UpdateSlideConfiguration = async (payload, onUploadProgress) => {
    try {
        const config = { onUploadProgress }
        return await Instance.instanceToken.put(`/slideconfiguration`, payload, config);
    } catch (error) {
        return error;
    }
};